'use client';
import React, { useEffect, useState } from 'react';
import { Script } from 'gatsby';
import { storyblokEditable } from 'gatsby-source-storyblok';
import PlayVideoButton from '../buttons/play_video_button';

const Webcam = ({ blok }) => {
  const widths = {
    'w-1/4': 'col-span-12 sm:col-span-6 md:col-span-3',
    'w-1/3': 'col-span-12 sm:col-span-6 md:col-span-4',
    'w-1/2': 'col-span-12 md:col-span-6',
    'w-2/3': 'col-span-12 sm:col-span-8',
    'w-3/4': 'col-span-12 sm:col-span-9',
    'w-full': 'col-span-12',
  };

  const width = widths[blok.width || 'w-full'];
  return (
    <div
      {...storyblokEditable(blok)}
      className={`${width} flex flex-col sm:flex-row mt-12 scroll-mt-20 aspect-4/3 mb-4`}
    >
      <WebCam blok={blok} />
    </div>
  );
};

const WebCam = ({ blok }) => {
  const { webcam_type } = blok;
  switch (webcam_type) {
    case 'feratel':
      return <FeratelWebcam {...blok} />;
    case 'panomax':
      return <PanomaxWebcam {...blok} />;
    case 'iframe':
      return <IframeWebcam {...blok} />;
    default:
      break;
  }
};

const IframeWebcam = (blok) => {
  const { _uid, webcam_url } = blok;

  return (
    <iframe
      className="w-full rounded"
      src={webcam_url.cached_url}
      id={_uid}
    ></iframe>
  );
};

const FeratelWebcam = (blok) => {
  const [showingWebcam, showWebcam] = useState(false);
  const { _uid, webcam_id, webcam_url } = blok;
  const imageUrl = webcam_id
    ? `https://wtvpict.feratel.com/picture/37/${webcam_id}.jpeg?dcsdesign=WTP_alpresor&design=noxdesign`
    : webcam_url.cached_url;

  const webcamUrl = webcam_id
    ? `https://webtv.feratel.com/webtv/?design=v5&cam=${webcam_id}&dcsdesign=WTP_alpresor&design=noxdesign`
    : webcam_url.cached_url;

  return (
    <>
      {!showingWebcam && (
        <div className="relative rounded">
          <img
            className="rounded aspect-4/3"
            src={imageUrl}
            onClick={() => showWebcam(!showingWebcam)}
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <PlayVideoButton
              size="35%"
              fillColorCircle="transparent"
              onClick={() => {
                showWebcam(true);
              }}
            />
          </div>
        </div>
      )}
      {showingWebcam && (
        <iframe className={`w-full rounded`} src={webcamUrl} id={_uid}></iframe>
      )}
    </>
  );
};

const PanomaxWebcam = (blok) => {
  const { webcam_id } = blok;
  const [loadedScript, setLoadedScript] = useState(false);

  const [scriptTag, setScriptTag] = useState(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://static.panomax.com/front/thumbnail/js/pmaxthumbnail.js';
    document.head.appendChild(script);
    setLoadedScript(true);
    return () => {
      script.remove();
    };
  }, []);

  return loadedScript && window?.PmaxThumbnail ? (
    <Script type="text/javascript">
      {`
PmaxThumbnail.place({
instanceLogo: false,
map: false,
instance: ${webcam_id}
});`}
    </Script>
  ) : (
    <div>Loading</div>
  );
};

export default Webcam;
